import React, { useState, useEffect } from 'react';

const Header = () => {
  const [headerScrolled, setHeaderScrolled] = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [activeLink, setActiveLink] = useState('hero');

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setHeaderScrolled(true);
      } else {
        setHeaderScrolled(false);
      }

      const navbarlinks = document.querySelectorAll('#navbar .scrollto');
      let position = window.scrollY + 200;
      navbarlinks.forEach(navbarlink => {
        if (!navbarlink.hash) return;
        let section = document.querySelector(navbarlink.hash);
        if (!section) return;
        if (position >= section.offsetTop && position <= (section.offsetTop + section.offsetHeight)) {
          setActiveLink(navbarlink.hash.substring(1));
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (e, hash) => {
    e.preventDefault();
    const element = document.querySelector(hash);
    if (element) {
      const headerHeight = document.getElementById('header').offsetHeight;
      window.scrollTo({
        top: element.offsetTop - headerHeight,
        behavior: 'smooth'
      });
      setMobileNavOpen(false);
      setActiveLink(hash.substring(1));
    }
  };

  return (
    <header id="header" className={`fixed-top ${headerScrolled ? 'header-scrolled' : ''}`}>
      <div className="container d-flex align-items-center justify-content-lg-between">
        <div className="glowLogoDiv">
          <span className="glowLogo">
            {/* <img src="assets/img/logo.png" alt="Logo" height="45" /> */}
            Abishek Electronic
          </span>
        </div>

        <nav id="navbar" className={`navbar order-last order-lg-0 ${mobileNavOpen ? 'navbar-mobile' : ''}`}>
          <ul>
            <li>
              <a 
                className={`nav-link scrollto ${activeLink === 'hero' ? 'active' : ''}`}
                href="#hero"
                onClick={(e) => scrollToSection(e, '#hero')}
              >
                Home
              </a>
            </li>
            <li>
              <a 
                className={`nav-link scrollto ${activeLink === 'about' ? 'active' : ''}`}
                href="#about"
                onClick={(e) => scrollToSection(e, '#about')}
              >
                Introduction
              </a>
            </li>
            <li>
              <a 
                className={`nav-link scrollto ${activeLink === 'services' ? 'active' : ''}`}
                href="#services"
                onClick={(e) => scrollToSection(e, '#services')}
              >
                Operational Excellence
              </a>
            </li>
            <li>
              <a 
                className={`nav-link scrollto ${activeLink === 'portfolio' ? 'active' : ''}`}
                href="#portfolio"
                onClick={(e) => scrollToSection(e, '#portfolio')}
              >
                Our Products
              </a>
            </li>
            <li>
              <a 
                className={`nav-link scrollto ${activeLink === 'contact' ? 'active' : ''}`}
                href="#contact"
                onClick={(e) => scrollToSection(e, '#contact')}
              >
                Contact
              </a>
            </li>
          </ul>
          <i 
            className={`bi ${mobileNavOpen ? 'bi-x' : 'bi-list'} mobile-nav-toggle`}
            onClick={() => setMobileNavOpen(!mobileNavOpen)}
          ></i>
        </nav>
      </div>
    </header>
  );
};

export default Header;
